<style lang="scss" scoped>
.welcome-message {
	margin-bottom: 48px;
	border: 2px dashed #d4d4d4;
	padding: 30px 30px;
	border-radius: 10px;
	color: #4b5658;
	background: white;
	cursor: pointer;
	&__close {
		float: right;
		font-size: 23px;
		padding-left: 20px;
	}
	&__emoji {
		width: 50px;
		height: auto;
		margin-right: 20px;
		float: left;
	}
}
</style>

<template lang="pug">
.welcome-message(v-if="User.is_admin && showMessage", @click="close")
    .welcome-message__text
        img.welcome-message__emoji(src="/static/img/misc/waving-hand.png")
        a.welcome-message__close
            i.fe.fe-x
        | This is where you can approve, manage and revoke access to your third party applications powered by Wonde. When an application requests access to your school's data they will appear here.
</template>

<script>
import cookie from "js-cookie";
import gql from "graphql-tag";

export default {
	data() {
		return {
			override: false
		};
	},

	computed: {
		showMessage() {
			return this.override === false && !cookie.get("disable-dashboard-welcome-message");
		}
	},

	methods: {
		close() {
			this.override = true;
			cookie.set("disable-dashboard-welcome-message", true);
		}
	},

	apollo: {
		User: {
			query: gql`
				{
					User {
						id
						is_admin
					}
				}
			`,
			fetchPolicy: "cache"
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/apps/appsList/cards/admin/WelcomeMessage.vue